import { createNetworkInterface, ApolloClient } from 'react-apollo';
import analytics from './site-render/src/lib/analytics';

export default function(isRegister, eventId) {
  const networkInterface = createNetworkInterface({
    uri: window.__API_URL__ || process.env.REACT_APP_API_URL,
    opts: {
      credentials: 'include',
    },
  });

  networkInterface.use([
    {
      applyMiddleware(req, next) {
        if (!req.options.headers) {
          req.options.headers = {};
        }

        req.options.headers['uuid'] = analytics.getUUID();

        const campaign = isRegister
          ? analytics.getLocalStorageCampaign(eventId)
          : analytics.getCookieCampaign();

        if (campaign) {
          req.options.headers['campaign'] = campaign;
        }

        next();
      },
    },
  ]);

  return new ApolloClient({ networkInterface });
}



// WEBPACK FOOTER //
// ./src/graphqlClient.js